export default __webpack_public_path__ + "ff3f23357689e27ef0e49bf2868ae338.png";